<template>
    <div class="container mt-4">
        <h2>Distributors</h2>

        <!-- Przycisk do dodania dystrybutora -->
        <bs5-base-button variant="success" class="mb-3" @click="openAddDistributorModal">
            <i class="bi bi-plus-lg"></i> Add Distributor
        </bs5-base-button>

        <!-- Tabela dystrybutorów -->
        <div class="table-responsive">
            <table class="table table-striped table-hover">
                <thead class="table-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(distributor, index) in distributors" :key="distributor.id as string">
                        <th scope="row">{{ index + 1 }}</th>
                        <td>{{ distributor.name }}</td>
                        <td>{{ distributor.description }}</td>
                        <td>
                            <bs5-group-button>
                                <bs5-edit-button @click="openEditDistributorModal(distributor.id as string)" />
                                <bs5-delete-button @click="deleteDistributor(distributor.id as string)" />
                            </bs5-group-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Modale -->
        <EditDistributorModal :visible="showEditDistributorModal" :distributorId="selectedDistributorId as string"
            @close="showEditDistributorModal = false" @distributor-updated="fetchDistributors" />

        <AddDistributorModal :visible="showAddDistributorModal" @close="showAddDistributorModal = false"
            @distributor-added="fetchDistributors" /> 
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import AddDistributorModal from "./modals/AddDistributorModal.vue";
import EditDistributorModal from "./modals/EditDistributorModal.vue";
import { showToast } from "@/utils/toast";
// import EditDistributorModal from "@/components/modals/EditDistributorModal.vue";
// import AddDistributorModal from "@/components/modals/AddDistributorModal.vue";

export default defineComponent({
    components: { AddDistributorModal, EditDistributorModal },
    data() {
        return {
            distributors: ref<Distributor[]>([]),
            loading: ref(false),
            showEditDistributorModal: ref(false),
            showAddDistributorModal: ref(false),
            selectedDistributorId: ref<string | null>(null),
        };
    },
    methods: {
        async fetchDistributors() {
            this.loading = true;
            try {
                const response = await distributorService.getDistributors();
                this.distributors = [...response];
            } catch (error) {
                console.error("Error fetching distributors:", error);
            } finally {
                this.loading = false;
            }
        },
        openEditDistributorModal(distributorId: string) {
            this.selectedDistributorId = distributorId;
            this.showEditDistributorModal = true;
        },
        openAddDistributorModal() {
            this.showAddDistributorModal = true;
        },
        async deleteDistributor(distributorId: string) {
            try {
                console.log("start");
                const response = await this.$swal.fire({
                    title: "Are you sure?",
                    text: "This action cannot be undone!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                });
                console.log(response);
                if (response.isConfirmed) {
                    try {
                        await distributorService.deleteDistributor(distributorId);
                        showToast("The distributor has been deleted.", "success");
                    } catch (error) {
                        showToast("Failed to delete distributor.", "error");
                        console.error("Error deleting distributor:", error);
                    }
                    finally{
                        this.fetchDistributors();
                    }
                }
            }
            catch (e) {
                console.log(e);
            }
            finally {
                console.log("end");
            }
        },
    },
    mounted() {
        this.fetchDistributors();
    },
});
</script>